import { render } from "./VirtualPowerPlantManagement.vue?vue&type=template&id=f3199a2a&scoped=true"
import script from "./VirtualPowerPlantManagement.vue?vue&type=script&lang=js"
export * from "./VirtualPowerPlantManagement.vue?vue&type=script&lang=js"

import "./VirtualPowerPlantManagement.vue?vue&type=style&index=0&id=f3199a2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3199a2a"]])

export default __exports__